import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { RuleInfo, RuleRequest } from '../main/models/rule-config';

@Injectable({
  providedIn: 'root',
})
export class RuleService {

  private url: string;

  constructor(private http: HttpClient) {
    this.url = environment.slideCropServer;
  }

  private join(path: string): string {
    // environment.slideCropServer can be absolute (https://...) or relative (/api/)
    // Ensure exactly one slash between base and path
    const base = this.url.endsWith('/') ? this.url : `${this.url}/`;
    const p = path.startsWith('/') ? path.substring(1) : path;
    return `${base}${p}`;
  }

  /** `scope: 'mine'` (default) is the caller's own rules; `'all'` is every rule
   *  on a bucket the caller can access (server-side visibility filter). */
  public list(scope: 'mine' | 'all' = 'mine'): Observable<RuleInfo[]> {
    const url = new URL(this.join('rule-configs'), window.location.origin);
    url.searchParams.set('scope', scope);
    return this.http.get<RuleInfo[]>(url.toString());
  }

  public get(id: number): Observable<RuleInfo> {
    return this.http.get<RuleInfo>(this.join(`rule-configs/${id}`));
  }

  public create(request: RuleRequest): Observable<RuleInfo> {
    return this.http.post<RuleInfo>(this.join('rule-configs'), request);
  }

  public update(id: number, request: RuleRequest): Observable<RuleInfo> {
    return this.http.put<RuleInfo>(this.join(`rule-configs/${id}`), request);
  }

  public delete(id: number): Observable<void> {
    return this.http.delete<void>(this.join(`rule-configs/${id}`));
  }

  public activate(id: number): Observable<RuleInfo> {
    return this.http.post<RuleInfo>(this.join(`rule-configs/${id}/activate`), {});
  }

  public deactivate(id: number): Observable<RuleInfo> {
    return this.http.post<RuleInfo>(this.join(`rule-configs/${id}/deactivate`), {});
  }
}
